<template lang="">
    <div>
        {{param}}

        <a @click="backPagina">Voltar</a>
    </div>
</template>
<script>
export default {
  data: () => ({
    param: null,
  }),
  mounted() {
    this.param = this.$route.params.id;
  },
  methods: {
    backPagina() {
      this.$router.replace({
        name: "inicial",
      });
    },
  },
};
</script>
<style lang="">
</style>